import { render, staticRenderFns } from "./producto.por.categoria.vue?vue&type=template&id=09c0abe2&scoped=true&"
import script from "./producto.por.categoria.vue?vue&type=script&lang=js&"
export * from "./producto.por.categoria.vue?vue&type=script&lang=js&"
import style0 from "./producto.por.categoria.vue?vue&type=style&index=0&id=09c0abe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c0abe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSkeletonLoader})
